import { createWebHistory, createRouter } from "vue-router";
// import axios from 'axios';
import routes from './routes';
import appConfig from "../../app.config";
import store from '@/state/store';
// import studentRoutes from "./student.routes";

const hasPermission = async (permission) => {
   const permissions = store.getters['authfack/get_user_permissions']

   if (!permissions || permissions.length === 0) {
      // If state.permissions is empty, fetch the permissions
      await store.dispatch('user/getPermissions')
    }

  return  store.getters['authfack/hasPermission'](permission);
};

const router = createRouter({
  history: createWebHistory(),
  // routes: configRoutes(),
  // routes: studentRoutes,
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});


router.beforeEach((routeTo, routeFrom, next) => {

    const publicPages = ['/login', '/register', '/forgot-password','/otp','/resetpassword'];
    const authpage = !publicPages.includes(routeTo.path);

    const loggeduser = localStorage.getItem('ENSPSID');

    if (authpage && !loggeduser) {
      return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }


      // Add a check for 404 page
      if (routeTo.matched.length === 0) {
        // No route found, redirect to 404 page
        return next({ name: '404' });
      }


    if (routeTo.matched.some(record => record.meta.authRequired)) {

      // Check if the user has permission to access the route

      const requiredPermission = routeTo.meta.requiredPermission;

      hasPermission(requiredPermission).then(
        hasPerm => {
          // console.log(hasPerm);
          if (hasPerm == false) {
              next({ name: '403' });
            
          } else {
            next();
          }
        }
      )
    } else{

      next();
    }

    // next()

});



router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title;
  // If we reach this point, continue resolving the route.
  next();
});

export default router;
